/* eslint-disable max-len */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-underscore-dangle */

import _ from 'underscore';
import config from '@bingads-webui-clientcenter/config';
import pageContext from 'PageContext';

const { clientConfigurationProps: clientConfiguration } = window._webpack_init_props;
delete window._webpack_init_props.clientConfigurationProps;

if (!_.isEmpty(clientConfiguration)) {
  config.set({
    CurrentUser: {
      Name: clientConfiguration.Username,
      Id: clientConfiguration.UserId,
      Email: clientConfiguration.UserEmail,
    },
    CurrentAccount: {
      AccountNumber: clientConfiguration.AccountNumber,
      ShortName: clientConfiguration.AccountName,
    },
    CurrentCustomer: {
      Id: clientConfiguration.CustomerId,
      Name: clientConfiguration.CustomerName,
    },
    Culture: pageContext.cultureName,
    // i18n component uses a lowercase culture
    culture: pageContext.cultureName,
    HelpModel: {
      BaseHelpUrl: clientConfiguration.HelpModel.BaseHelpUrl,
    },
    SupportOptions: clientConfiguration.SupportOptions,
    CampaignAzureDomain: clientConfiguration.CampaignAzureDomain,
    IsProdEnv: clientConfiguration.IsProdEnv,
    CCBaseUrl: clientConfiguration.ClientCenterBaseUrl,
    FwLinkBaseUrl: clientConfiguration.FwLinkBaseUrl,
    'odata.url': clientConfiguration.ODataBaseUrl,
    CookieDomain: clientConfiguration.CookieDomain,
    CookiePath: '/',
    GreenIdUrl: clientConfiguration.GreenIdUrl,
  });

  if (clientConfiguration.NumberFormatInfo != null) {
    config.set({
      CurrencySymbol: clientConfiguration.NumberFormatInfo.CurrencySymbol,
      'globalization.number.decimalpoint': clientConfiguration.NumberFormatInfo.CurrencyDecimalSeparator,
      'globalization.number.groupPoint': clientConfiguration.NumberFormatInfo.CurrencyGroupSeparator,
      'globalization.number.groupSize': clientConfiguration.NumberFormatInfo.CurrencyGroupSizes[0],
      'globalization.number.numberOfDigits': clientConfiguration.NumberFormatInfo.CurrencyDecimalDigits,
      'globalization.number.percentSymbol': clientConfiguration.NumberFormatInfo.PercentSymbol,
      'globalization.number.percentGroupSize': clientConfiguration.NumberFormatInfo.PercentGroupSizes[0],
      'globalization.number.percentGroupSeparator': clientConfiguration.NumberFormatInfo.PercentGroupSeparator,
      'globalization.number.percentPositivePattern': clientConfiguration.NumberFormatInfo.PercentPositivePattern,
      'globalization.number.percentDecimalDigits': clientConfiguration.NumberFormatInfo.PercentDecimalDigits,
      'globalization.number.percentDecimalSeparator': clientConfiguration.NumberFormatInfo.PercentDecimalSeparator,
    });
  }
}
